import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { retrieveSavedOrdersStatus } from "store/features/library.store";
import { fetchSavedOrdersRequest } from "store/requests/library.requests";
import useNewOrderMachine from "./hooks/useNewOrderMachine";

const withImportedOrder = (Component) => (props) => {
  const dispatch = useDispatch();

  const { idle: ordersIdleStatus } = useSelector(retrieveSavedOrdersStatus);

  const [, , { onInitializeForm }] = useNewOrderMachine();

  const handleImportOrder = useCallback(({ order }) => onInitializeForm({ order }), [onInitializeForm]);

  useEffect(() => {
    if (!ordersIdleStatus) return;
    dispatch(fetchSavedOrdersRequest());
  }, [ordersIdleStatus, dispatch]);

  return <Component {...props} handleImportOrder={handleImportOrder} />;
};

export default withImportedOrder;
